/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReviewWorkshopCount } from './ReviewWorkshopCount';
import {
    ReviewWorkshopCountFromJSON,
    ReviewWorkshopCountFromJSONTyped,
    ReviewWorkshopCountToJSON,
    ReviewWorkshopCountToJSONTyped,
} from './ReviewWorkshopCount';

/**
 * Results waiting for review in the caller's workshops.
 * 
 * `total` counts each result (submission and test case) once, also when it sits in the queues of
 * several workshops; `workshops` is the top 5 by their own queue size.
 * @export
 * @interface ReviewSummary
 */
export interface ReviewSummary {
    /**
     * 
     * @type {number}
     * @memberof ReviewSummary
     */
    total?: number;
    /**
     * 
     * @type {Array<ReviewWorkshopCount>}
     * @memberof ReviewSummary
     */
    workshops?: Array<ReviewWorkshopCount>;
}

/**
 * Check if a given object implements the ReviewSummary interface.
 */
export function instanceOfReviewSummary(value: object): value is ReviewSummary {
    return true;
}

export function ReviewSummaryFromJSON(json: any): ReviewSummary {
    return ReviewSummaryFromJSONTyped(json, false);
}

export function ReviewSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReviewSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'] == null ? undefined : json['total'],
        'workshops': json['workshops'] == null ? undefined : ((json['workshops'] as Array<any>).map(ReviewWorkshopCountFromJSON)),
    };
}

export function ReviewSummaryToJSON(json: any): ReviewSummary {
    return ReviewSummaryToJSONTyped(json, false);
}

export function ReviewSummaryToJSONTyped(value?: ReviewSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'workshops': value['workshops'] == null ? undefined : ((value['workshops'] as Array<any>).map(ReviewWorkshopCountToJSON)),
    };
}

